<template>
	<section class="grid">
		<div class="filter-search-bar">
			<div>
				<p class="filter-option active" @click="filterFunction($event, 'all')">
					Alla Center
				</p>
			<!--	<p class="filter-option" @click="filterFunction($event)">
					Nordic Wellness Padelcenter
				</p>
				<p class="filter-option" @click="filterFunction($event)">
					Life
				</p>-->
			</div>
		</div>
		<div class="filter-mobile">
			<div>
				<p
					ref="togglemodalRef"
					class="toggle-modal-btn active"
					@click="handleModal()"
				>
					{{ this.currentFilter }}
				</p>
			</div>
			<filter-modal
				ref="modalRef"
				@filterFunc="filterFunction"
				@toggleModal="handleModal"
			/>
		</div>
	</section>
</template>
<script>
export default {
	components: {
		'filter-modal': () => import('@/components/FilterModal.vue'),
	},
	props: {
		currentFilter: { type: String },
	},
	methods: {
		filterFunction: function (...args) {
			this.$emit('filterFunction', ...args)
		},
		handleModal: function () {
			this.$refs.modalRef.$el.classList.toggle('modal-open')
			this.$refs.togglemodalRef.classList.toggle('rotate')
			document.body.classList.toggle('modal-open')
		},
	},
}
</script>
<style lang="scss">
.grid {
	padding-top: 0;
	padding-bottom: 0;
	.section-content-wrapper {
		& > div:nth-of-type(1) {
			width: 100%;

			@include card-grid;
		}
	}
}

.filter-search-bar {
	display: flex;
	width: 100%;
	max-width: 1410px;
	justify-content: space-between;
	padding-top: 50px;
	padding-bottom: 50px;

	@include max-width(small) {
		display: none;
	}

	& > div:first-child {
		display: flex;

		p {
			@include paragraph-small;
			font-family: $secondary-font-sbold;
			margin-right: 40px;
			text-transform: uppercase;
			cursor: pointer;
			transition: all 0.2s ease;
			border: 2px solid #fff;

			&:last-child {
				margin-right: 0;
			}

			&.active {
				color: $color-green;
				border-bottom: 2px solid $color-green;
			}
		}
	}
}

.filter-mobile {
	display: none;
	width: 100%;
	max-width: 1410px;
	padding: 35px 0;
	text-transform: uppercase;
	.filter-modal {
		&.modal-open {
			display: flex;
		}
	}
	@include max-width(small) {
		display: flex;
	}

	& > div:nth-of-type(1) p {
		color: $color-green;
		display: flex;

		&::after {
			display: block;
			pointer-events: all;
			content: '\33';
			font-family: $elegant-icons;
			font-size: 30px;
			transform: none;
			cursor: pointer;
		}

		&.rotate {
			&::after {
				transform: rotate(180deg) !important;
			}
		}
	}

	p {
		font-family: $secondary-font-sbold;
		font-size: 14px;
		letter-spacing: 0.7px;
	}
}
</style>
